import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { useSession } from './store/session'
import { subscribeCrossTabLogout } from './api/client'
import { RequireAuth } from './auth/RequireAuth'
import { Login } from './auth/Login'
import { AppShell } from './shell/AppShell'
import { RequirePermission } from './rbac/RequirePermission'
import { Dashboard } from './screens/Dashboard'
import { Transactions } from './screens/Transactions'
import { Accounts } from './screens/Accounts'
import { Gateways } from './screens/Gateways'
import { Users } from './screens/Users'
import { Roles } from './screens/Roles'
import { Audit } from './screens/Audit'
import { Account } from './screens/Account'
import { SystemConfig } from './screens/SystemConfig'

// Sentry-instrumented Routes → transactions get route-pattern names (e.g. /transactions) instead of raw URLs.
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

export function App() {
  const boot = useSession((s) => s.boot)
  useEffect(() => {
    void boot()
  }, [boot])
  // Cross-tab logout: when another tab signs out, drop this tab's session too.
  useEffect(() => subscribeCrossTabLogout(() => useSession.getState().externalLogout()), [])

  return (
    <SentryRoutes>
      <Route path="/login" element={<Login />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route index element={<RequirePermission perm="view:dashboard"><Dashboard /></RequirePermission>} />
          <Route path="transactions" element={<RequirePermission perm="view:transactions"><Transactions /></RequirePermission>} />
          <Route path="accounts" element={<RequirePermission perm="view:accounts"><Accounts /></RequirePermission>} />
          <Route path="gateways" element={<RequirePermission perm="view:gateways"><Gateways /></RequirePermission>} />
          <Route path="audit" element={<RequirePermission perm="view:audit"><Audit /></RequirePermission>} />
          <Route path="users" element={<RequirePermission perm="manage:rbac"><Users /></RequirePermission>} />
          <Route path="roles" element={<RequirePermission perm="manage:rbac"><Roles /></RequirePermission>} />
          <Route path="config" element={<RequirePermission perm="manage:config"><SystemConfig /></RequirePermission>} />
          <Route path="account" element={<Account />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </SentryRoutes>
  )
}
